import { h, Component, Host, Element, Prop } from '@stencil/core';

@Component({
  tag: 'pk-spinner',
  styleUrl: './scss/pk-spinner.scss',
  shadow: true,
})
export class PkSpinner {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkSpinnerElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Specify primary size font */
  @Prop() primaryFontSize: string | number;

  /** Specify secondary size font */
  @Prop() secondaryFontSize: string | number;

  /** Specify animation size */
  @Prop() size: string | number;

  /** Specify orientation size */
  @Prop() type: 'landscape' | 'portrait' = 'portrait';

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    const style = {
      ...(this.primaryFontSize && { '--pk-spinner--primary-size': `${this.primaryFontSize}px` }),
      ...(this.secondaryFontSize && { '--pk-spinner--secondary-size': `${this.secondaryFontSize}px` }),
      ...(this.size && { '--pk-spinner--size': `${this.size}px` }),
    };

    return (
      <Host style={{ ...style }}>
        <div class={`inline-flex w-full flex-col items-center justify-center ${this.type}`} part="content">
          <div class="loader" part="loader">
            <div class="loader--spinner" part="spinner" />
          </div>
          <div class={this.type} part="text-wrapper">
            <div
              class="primary text-center text-[length:var(--spinner--primary-size)] leading-[var(--spinner--primary-lineHeight)] text-[color:var(--spinner--primary-color)]"
              part="primary"
            >
              <slot name="primary" />
            </div>
            <div
              class="secondary text-center text-[length:var(--spinner--secondary-size)] leading-[var(--spinner--secondary-lineHeight)] text-[color:var(--spinner--secondary-color)]"
              part="secondary"
            >
              <slot name="secondary" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
